<template>
  <div class="operation-area">
    <el-button @click="goHome"> 返回 </el-button>
  </div>
  <div class="area-info">
    <div>区域信息</div>
    <el-form label-width="auto" :model="areaConfig" style="max-width: 600px">
      <el-form-item label="区域名称">
        <el-input v-model="areaConfig.areaName" :disabled="!ifChange" />
      </el-form-item>
      <el-form-item label="区域颜色">
        <el-color-picker v-model="areaConfig.markColor" :disabled="!ifChange" />
      </el-form-item>
    </el-form>
    <el-button
      type="button"
      v-if="!polygon.isDrawing && !areaConfig.markColor"
      @click="polygon.toggle"
    >
      添加区域
    </el-button>
    <el-button
      type="button"
      v-if="polygon.isDrawing && !areaConfig.markColor"
      @click="polygon.toggle"
    >
      关闭添加
    </el-button>
    <el-button v-if="!ifChange && areaConfig.markColor" @click="goEditMap"
      >修改信息</el-button
    >
    <el-button v-if="ifChange && areaConfig.markColor" @click="saveEditMap"
      >保存修改</el-button
    >
    <!-- <el-button
      type="button"
      :class="{ active: isDeleteAreaActive }"
      @click="deleteArea"
    >
      删除区域
    </el-button> -->
  </div>
  <div class="map-wrapper">
    <div class="map-item">
      <BMap
        :center="{ lng: 120.0267003252203, lat: 31.784177543847555 }"
        :zoom="16"
        enable-scroll-wheel-zoom
        @initd="handleInitd"
        height="100vh"
        width="100%"
      >
      </BMap>
    </div>
  </div>
  <!-- <div>
    <p>区域名称:{{ areaConfig.areaName }}</p>
    <p>填充颜色{{ areaConfig.strokeColor }}</p>
    <p>区域坐标</p>
  </div> -->
</template>
<script setup>
import { ref, onMounted, reactive } from "vue";
import { BMap } from "vue3-baidu-map-gl";
import { postal } from "../../../api/index";
import { useRouter, useRoute } from "vue-router";
import { ElMessage } from "element-plus";

const router = useRouter();
const route = useRoute(); // 获取当前路由实例
const ifChange = ref(false);
const goHome = () => {
  router.push({
    path: "/mapManage",
  });
};
let areaId = ref(route.query.areaId);
const regionId = ref(route.query.regionId);

let areaConfig = reactive({
  areaId: 0,
  areaName: "",
  markColor: "",
});
let editOverlay = ref({});
let overlayers = ref([]);
let isDeleteAreaActive = ref(false);
let mapInstance = null;
let scene = reactive({});

const getAreaConfig = () => {
  postal.areaDetail(areaId.value).then((res) => {
    Object.assign(areaConfig, res.data);
  });
};

getAreaConfig();

// 重载绘制区域
const loadMap = async () => {
  const res = await postal.loadMap(regionId.value);
  overlayers.value.forEach((overlay) => {
    mapInstance.removeOverlay(overlay); // 从地图中移除
  });
  overlayers.value = []; // 清空数组
  res.data.forEach((area) => {
    if (area.areaPosition) {
      const pointsArray = JSON.parse(area.areaPosition);
      const overlayPoints = pointsArray.map(
        (point) => new BMapGL.Point(point.lng, point.lat)
      );
      const polygon = new BMapGL.Polygon(overlayPoints, {
        strokeColor: area.markColor,
        strokeWeight: 1,
        strokeOpacity: 1,
        areaName: area.areaName,
        areaId: area.areaId,
      });
      if (area.areaId == areaId.value) {
        editOverlay.value = polygon;
        polygon.setFillColor(area.markColor);
      }
      polygon.markColor = area.markColor;
      polygon.areaId = area.areaId;
      overlayers.value.push(polygon);
    }
  });
  // 绘制面并增加监听事件
  overlayers.value.forEach((overlay) => {
    mapInstance.addOverlay(overlay);

    overlay.addEventListener("click", () => {
      // handleOverlayClick;
    });
    overlay.addEventListener("mouseover", () =>
      overlay.setFillColor(overlay.markColor)
    );
    overlay.addEventListener("mouseout", () => {
      if (overlay.areaId != areaId.value) {
        overlay.setFillColor("#fff");
      }
    });
  });
};

// 随机绘制颜色
let color = ref();
function getRandomColor() {
  const randomColor = Math.floor(Math.random() * 16777215).toString(16);
  color.value = `#${randomColor.padStart(6, "0")}`;
}

getRandomColor();

let polygon = ref({
  instance: null,
  isDrawing: false,
  edit: null,
  isEditing: false,
  toggle() {
    let _polygon = polygon.value;
    _polygon.isDrawing
      ? _polygon.instance.closeAll()
      : _polygon.instance.open();
    _polygon.isDrawing = !_polygon.isDrawing;
  },
  toEdit(overlay) {
    let _polygon = polygon.value;
    if (_polygon.isEditing) {
      _polygon.edit.open(overlay);
    } else {
      _polygon.edit.close();
    }
  },
});

// function deleteArea() {
//   const confirmed = confirm(
//     "你确定要删除区域: " + areaConfig.areaName + " 吗?"
//   );
//   if (confirmed) {
//     postal
//       .removeMap(areaConfig.areaId)
//       .then(() => {
//         alert("区域已成功删除!");
//         areaConfig.areaId = 0;
//         areaConfig.areaName = "";
//         areaConfig.markColor = "";
//         loadMap();
//       })
//       .catch(() => {
//         alert("删除区域时发生错误，请稍后重试!");
//       });
//   }
// }

const handleInitd = async ({ map }) => {
  mapInstance = map;
  const { DrawScene, PolygonDraw, OperateEventType, PolygonEdit } =
    await import("bmap-draw");
  // 场景类
  scene = new DrawScene(map, { noLimit: true, enableSnap: true });

  scene.addEventListener(OperateEventType.COMPLETE, (event) => {
    const pointArray = event.target.overlay._userPoints;
    const newOverlay = event.target.overlay;
    // overlayers.value.push(newOverlay);
    const convert = new BMapGL.Convertor();
    const pointPromises = pointArray.map((element) => {
      return new Promise((resolve) => {
        let array = [];
        array.push(element);
        convert.translate(
          array,
          COORDINATES_BD09_MC,
          COORDINATES_BD09,
          (data) => {
            resolve(data.points[0]);
          }
        );
      });
    });

    Promise.all(pointPromises).then((newPointsArray) => {
      if (!polygon.value.isEditing) {
        const newArea = {
          areaPosition: JSON.stringify(newPointsArray),
          markColor: color.value,
          areaId: areaId.value,
        };
        postal.updateArea(newArea).then((res) => {
          if (res.code == 200) {
            ElMessage({
              type: "success",
              message: `规划区域成功`,
            });
            polygon.value.toggle();
            getAreaConfig();
            loadMap();
          } else {
            ElMessage({ type: "error", message: `规划区域失败` });
            map.removeOverlay(newOverlay);
            overlayers.value.pop();
          }
        });
      }
      if (polygon.value.isEditing) {
        const newArea = {
          areaPosition: JSON.stringify(newPointsArray),
          areaId: areaConfig.areaId,
        };
        postal.updateArea(newArea);
      }
      // console.log(points);
      // 打印转换后的点数组
    });
  });

  // 多边形绘制类
  polygon.value.instance = new PolygonDraw(scene, {
    isOpen: false,
    labelOptions: {
      borderRadius: "1px",
      background: "#b5d3fb",
      border: "1px solid #b5d3fb",
      color: "#666",
      fontSize: "12px",
      letterSpacing: "0",
      padding: "5px",
    },
    baseOpts: {
      strokeColor: color.value,
      fillColor: color.value,
      strokeWeight: 1,
      strokeOpacity: 1,
    },
  });
  polygon.value.edit = new PolygonEdit(scene);
};

function handleOverlayClick(e) {
  editOverlay.value = e.target;
  areaConfig.areaName = e.target._config.areaName;
  areaConfig.markColor = e.target._config.strokeColor;
  areaConfig.areaId = e.target._config.areaId;
}

const goEditMap = () => {
  ifChange.value = true;
  polygon.value.isEditing = true;
  polygon.value.toEdit(editOverlay.value);
};
const saveEditMap = () => {
  scene.close();
  areaConfig.areaPosition = "";
  postal.updateArea(areaConfig).then((res) => {
    if (res.code == 200) {
      loadMap();
    }
  });
  ifChange.value = false;
};

onMounted(() => {
  loadMap();
});
</script>
<style scoped>
.map-wrapper {
  width: 100%;
  z-index: 1;
}

.styled-button.active {
  background-color: #4caf50; /* 选中时的深色背景 */
  color: white;
}
.operation-area {
  position: absolute;
  height: 10vh;
  width: 100vw;
  top: 10px;
  z-index: 10;
  pointer-events: auto;
}
.area-info {
  top: 10px;
  right: 10px;
  background-color: white;
  position: absolute;
  z-index: 10;
  padding: 10px;
  border-radius: 10px;
  border: rgba(54, 65, 79, 1) 1px solid;
}
</style>
